import { render, staticRenderFns } from "./I18nGroupRow.vue?vue&type=template&id=2193f43a&"
import script from "./I18nGroupRow.vue?vue&type=script&lang=js&"
export * from "./I18nGroupRow.vue?vue&type=script&lang=js&"
import style0 from "./I18nGroupRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports